export const toTimeWalkNumber = (distance: string | null): number => {
  if (!distance) {
    return 0;
  }

  return Number(distance.split(' ').pop());
};
